import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface TimerProps {
  deadline: number | null; // timestamp ms
  totalMs?: number;
  compact?: boolean;
}

export function ActionTimer({ deadline, totalMs = 18000, compact }: TimerProps) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!deadline) return;
    const id = setInterval(() => setNow(Date.now()), 100);
    return () => clearInterval(id);
  }, [deadline]);

  if (!deadline) return null;

  const remainingMs = Math.max(0, deadline - now);
  const fraction = Math.min(1, remainingMs / totalMs);
  const seconds = Math.ceil(remainingMs / 1000);
  const isUrgent = fraction < 0.3;

  return (
    <div className={compact ? 'w-10' : 'w-16'}>
      <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
        <motion.div
          className={`h-full rounded-full ${isUrgent ? 'bg-rose-500' : 'bg-emerald-400'}`}
          animate={{ width: `${fraction * 100}%` }}
          transition={{ ease: 'linear', duration: 0.1 }}
        />
      </div>
      {!compact && (
        <div className={`text-center text-[11px] mt-0.5 tabular-nums ${isUrgent ? 'text-rose-400' : 'text-white/60'}`}>
          {seconds}с
        </div>
      )}
    </div>
  );
}
